
// BotoesDeAcao.js

import React from 'react';
import Button from '@mui/material/Button';
import NewIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import ListIcon from '@mui/icons-material/List';
import ReportIcon from '@mui/icons-material/Report';

const BotoesDeAcao = ({
  handleNovoClick,
  handleEditClick,
  handleDeleteClick,
  handleSearchClick,
  handleListarClick, // Adicione esta propriedade para lidar com o evento de listar
  isSearchVisible,
  handleSearchChange,
  searchQuery,
  //handleSearchByField,
  handleSearchByCodigo,
  handleSearchByNome,
  handleSearchByCNPJ,
}) => {
  
  const buttonStyles = {
    marginRight: '10px',
    minWidth: '60px',
    padding: '3px 6px',
    fontSize: '0.7rem',
  };


  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', marginTop: '10px' }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<NewIcon />}
          style={buttonStyles}
          onClick={handleNovoClick}
        >
          Novo
        </Button>

        <Button
          variant="contained"
          color="primary"
          startIcon={<EditIcon />}
          style={buttonStyles}
          onClick={handleEditClick}
        >
          Editar
        </Button>

        <Button
          variant="contained"
          color="primary"
          startIcon={<DeleteIcon />}
          style={buttonStyles}
          onClick={handleDeleteClick}
        >
          Excluir
        </Button>

        <Button
          variant="contained"
          color="primary"
          startIcon={<SearchIcon />}
          style={buttonStyles}
          onClick={handleSearchClick}
        >
          Buscar
        </Button>

        <Button
          variant="contained"
          color="primary"
          startIcon={<ListIcon />}
          style={buttonStyles}
          onClick={handleListarClick} // Adicione esta linha para lidar com o evento de listar
        >
          Listar
        </Button>

        <Button
          variant="contained"
          color="primary"
          startIcon={<ReportIcon />}
          style={buttonStyles}
        >
          Relatórios
        </Button>

      </div>

      {isSearchVisible && (
        <div style={{ display: 'flex', justifyContent: 'center', height: '20px', marginTop: '0px' }}>
          <TextField
            label="Buscar por Código"
            variant="outlined"
            size="small"
            sx={{
            '& .MuiInputBase-root': {
            height: '30px', marginRight: '10px'
            },
            '& .MuiInputLabel-root': {
            lineHeight: '15px',
            },
            }}
            style={{ height: '10px', marginRight: '10px' }}
            name="codigo"
            value={searchQuery.codigo}
            onChange={handleSearchChange}
            onKeyDown={handleSearchByCodigo} 
          />
          <TextField
            label="Buscar por Nome"
            variant="outlined"
            size="small"
             sx={{
            '& .MuiInputBase-root': {
            height: '30px', marginRight: '10px'
            },
            '& .MuiInputLabel-root': {
            lineHeight: '15px',
            },
            }}
            name="nome"
            value={searchQuery.nome}
            onChange={handleSearchChange}
            onKeyDown={handleSearchByNome} 
          />
          <TextField
            label="Buscar por CNPJ"
            variant="outlined"
            size="small"
            sx={{
            '& .MuiInputBase-root': {
            height: '30px', marginRight: '10px'
            },
            '& .MuiInputLabel-root': {
            lineHeight: '15px',
            },
            }}
            style={{ height: '10px', marginRight: '10px' }}
            name="cnpj"
            value={searchQuery.cnpj}
            onChange={handleSearchChange}
            onKeyDown={handleSearchByCNPJ} 
          />
        </div>
      )}
      
    </div>
  );
};

export default BotoesDeAcao;